import { render, staticRenderFns } from "./activityPropDetails.vue?vue&type=template&id=b22caf32&scoped=true&"
import script from "./activityPropDetails.vue?vue&type=script&lang=js&"
export * from "./activityPropDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22caf32",
  null
  
)

export default component.exports